import React from 'react';
import { Card, CardBody, CardHeader, CardProps, Flex, Link as ChakraLink, SimpleGrid, Text } from '@chakra-ui/react';
import StoreFrontIcon from '../../../components/icons/StoreFrontIcon';
import { legalTypeToString } from '../../../domain/legalType';
import { FaRegUser } from 'react-icons/fa';
import { IoIosArrowDropright } from 'react-icons/io';
import { Link as RouterLink } from 'react-router-dom';
import { Merchant } from '../../../domain/merchant';
import { SimpleDescription } from '../../../components/SimpleDescription';

interface MerchantCardProps extends CardProps {
  merchant: Merchant;
}

export const MerchantCard = (props: MerchantCardProps) => {
  const {
    merchant: {
      id,
      legal_type,
      activity,
      business_name,
      representative_firstname,
      representative_lastname,
      representative_number,
      tax_id,
      identifier,
    }, ...cardProps
  } = props;


  return (<Card shadow="none" borderColor="gray.200" borderRadius="xl" borderWidth="1px" {...cardProps}>
    <CardHeader paddingBottom="l">
      <Flex alignItems="center">
        <StoreFrontIcon />
        <Text marginLeft="l" fontWeight="500">{business_name}</Text>
        <ChakraLink as={RouterLink} marginLeft="auto" to={'merchants/' + id} color="primary.800">
          <Flex alignItems="center">
            <Text marginRight="l">Ver detalles</Text>
            <IoIosArrowDropright />
          </Flex>
        </ChakraLink>
      </Flex>
    </CardHeader>
    <CardBody paddingTop="0">
      <SimpleGrid columns={2} spacing={2}>
        <SimpleDescription label="ID" description={identifier?.toString()} />
        <SimpleDescription label="Entidad" description={legalTypeToString(legal_type)} />
        <SimpleDescription label="Razón social" description={business_name} />
        <SimpleDescription label="RFC" description={tax_id} />
        <SimpleDescription label="Actividad económica" description={activity} />
      </SimpleGrid>

      <Flex alignItems="center" marginY="xl">
        <FaRegUser />
        <Text marginLeft="l" fontWeight="500"> Datos del representante legal</Text>
      </Flex>
      <SimpleGrid columns={2} spacing={2}>
        <SimpleDescription label="Nombre" description={representative_firstname} />
        <SimpleDescription label="Apellido" description={representative_lastname} />
        <SimpleDescription label="Caracter" description="Apoderado" />
        <SimpleDescription label="RFC" description={representative_number} />
      </SimpleGrid>
    </CardBody>
  </Card>);
};

